import React from 'react';
import {
  CatCard,
  CatHeading,
  CatIconArrowForward
} from 'components/blocks-components';
import styles from './parts-item.module.scss';
import { extractPartNumber } from 'utils/common';

interface PartsItemProps {
  title: string;
  graphicSVG?: string;
  onClick: () => void;
}

const PartItemContent = ({
  title1,
  title2,
  showIcon
}: {
  title1: string;
  title2: string;
  showIcon: boolean;
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center p-2">
      <div className="d-flex align-items-center">
        <div className="ms-2">
          <CatHeading variant="body">
            <span className="fw-bold">{title1}</span>
          </CatHeading>
          <CatHeading variant="body-sm">{title2}</CatHeading>
        </div>
      </div>
      <CatIconArrowForward
        data-testid="cat-icon-arrow-forward"
        className="text-gray-400"
      />
    </div>
  );
};

const PartsItem: React.FC<PartsItemProps> = ({
  title,
  graphicSVG,
  onClick
}) => {
  const hasGraphic = Boolean(graphicSVG);
  const { title1, title2 } = extractPartNumber(title);
  return (
    <CatCard
      data-testid="cat-card"
      className={`${styles['card-widget']}`}
      onClick={() => onClick()}
    >
      {hasGraphic && (
        <div className="flex flex-col">
          <div className="bg-white rounded-lg p-2 min-h-42 flex items-center justify-center">
            <div dangerouslySetInnerHTML={{ __html: graphicSVG as string }} />
          </div>
        </div>
      )}
      <PartItemContent title1={title1} title2={title2} showIcon={!hasGraphic} />
    </CatCard>
  );
};

export default PartsItem;
